var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7026 6.75764L15.808 2.25266C15.625 2.08422 15.3735 2 15.1219 2H3.96062C3.43465 2 3 2.39991 3 2.88424V21.1158C3 21.5999 3.43446 22 3.96062 22H20.0392C20.5652 22 20.9998 21.6001 20.9998 21.1158L21 7.38966C21 7.15802 20.8855 6.92636 20.7027 6.75793L20.7026 6.75764ZM4.92153 20.2312V3.7681H13.7043V7.81014C13.7043 8.29429 14.1388 8.69437 14.6649 8.69437H19.0561V20.2102L4.92187 20.2104L4.92153 20.2312Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05512 17.559H15.9459C16.1061 17.559 16.2432 17.4327 16.2432 17.2853V16.0432C16.2432 15.8958 16.1061 15.7695 15.9459 15.7695H8.05512C7.89496 15.7695 7.75781 15.8958 7.75781 16.0432V17.2853C7.75781 17.4537 7.89496 17.559 8.05512 17.559Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05512 13.1371H15.9459C16.1061 13.1371 16.2432 13.0108 16.2432 12.8634V11.6213C16.2432 11.4739 16.1061 11.3477 15.9459 11.3477H8.05512C7.89496 11.3477 7.75781 11.4739 7.75781 11.6213V12.8634C7.75781 13.0108 7.89496 13.1371 8.05512 13.1371Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheet);
export default __webpack_public_path__ + "static/media/sheet.c56dd1ed7d7249c6efe3e833729a3e08.svg";
export { ForwardRef as ReactComponent };